import 'slick';

( function( $ ) {
	'use strict';

	$( '.image-slider__wrap' ).each( function(){
		const $this = $( this );
		if ( 1 < $this.children().length ) {
			$this.slick( {
				arrows: true,
				dots: true,
				infinite: true,
				slidesToShow: 1,
				slidesToScroll: 1,
				speed: 1000,
				autoplaySpeed: 10000,
				pauseOnHover: true,
				mobileFirst: true,
				swipe: true,
				fade: false,
				autoplay: true,
				adaptiveHeight: true,
				prevArrow: '<button class="icon-arrow-right"></button>',
				nextArrow: '<button class="icon-arrow-left"></button>',
				responsive: [
					{
						breakpoint: 768,
						settings: {
							fade: true
						}
					}
				]
			} );
		}
	} );
} )( jQuery );